import * as yup from 'yup'

export const businessSignUpSchema = yup.object({
  firstName: yup
    .string()
    .required('First name is required')
    .max(50, 'First name must be at most 50 characters'),
  lastName: yup
    .string()
    .required('Last name is required')
    .max(50, 'Last name must be at most 50 characters'),
  email: yup.string().email('Invalid email address').required('Email is required'),
  password: yup
    .string()
    .required('Password is required')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/,
      'Password must be 8 characters, including uppercase, special character,and number'
    )
})

export const resetSchema = yup.object({
  confirmationCode: yup
    .string()
    .required('Confirmation code is required')
    .max(50, 'Confirmation code must be at most 50 characters'),
  newPassword: yup
    .string()
    .required('Password is required')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/,
      'Password must be 8 characters, including uppercase, special character,and number'
    )
})
export const forgetpasswordSchema = yup.object({
  email: yup.string().email('Invalid email address').required('Email is required')
})
export const changePasswordSchema = yup.object({
  currPassword: yup
    .string()
    .required('Password is required')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/,
      'Password must be 8 characters, including uppercase, special character,and number'
    ),
  newPassword: yup
    .string()
    .required('Password is required')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/,
      'Password must be 8 characters, including uppercase, special character,and number'
    )
})

export const LoginSchema = yup.object({
  email: yup.string().email('Invalid email address').required('Email is required'),
  password: yup
    .string()
    .required('Password is required')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/,
      'Password is incorrect'
    )
})

export const PortalPassSchema = yup.object({
  password: yup.string().required('Password is required')
  // .matches(
  //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/,
  //   "Password is incorrect"
  // ),
})

export const roleSchema = yup.object({
  name: yup.string().required('Role is required').max(50, 'role must be at most 50 characters')
})

export const subsribeSchema = yup.object({
  email: yup.string().email('Invalid email address').required('Email is required')
})

export const UserUpdateSchema = yup.object({
  first_name: yup
    .string()
    .required('First name is required')
    .max(50, 'First name must be at most 50 characters'),
  last_name: yup
    .string()
    .required('Last name is required')
    .max(50, 'Last name must be at most 50 characters')
})
export const AdminSchema = yup.object({
  role: yup.mixed().required('Role is required').notOneOf([''], 'Role is required'),
  email: yup.string().email('Invalid email address').required('Email is required')
})

export const CustomEmailSchema = yup.object({
  subject: yup
    .string()
    .required('Subject is required')
    .matches(/^(?!\s*$).+/, 'Enter a valid subject'),
  stream: yup.string().required('Stream is required'),
  recipents: yup
    .array()
    .of(yup.number().required('Recipient is required'))
    .min(1, 'Please select at least one recipient'),
  s_date: yup.mixed().required('Date is required'),
  s_time: yup.mixed().required('Time is required')
})

export const TestEmailArraySchema = yup.object({
  email: yup
    .array()
    .of(yup.string().email('Invalid email').required('Required'))
    .min(1, 'Please add at least one email')
    .required('Email is required') // 👈 important
})

export const EditProfileSchema = yup.object({
  first_name: yup
    .string()
    .required('First Name is Required')
    .max(50, 'First name must be at most 50 characters'),
  last_name: yup
    .string()
    .required('Last name is required')
    .max(50, 'Last name must be at most 50 characters'),
  email: yup.string().email('Invalid email address'),
  contact: yup
    .string()
    .trim()
    .matches(/^(?=.*\d)[+]?[0-9\s()-]{6,20}$/, {
      message: 'Phone number is not valid. Please enter a valid number.',
      excludeEmptyString: true
    }),
  street: yup.string().max(50, 'Street must be at most 50 characters'),
  city: yup.string().max(50, 'City must be at most 50 characters'),
  postcode: yup.string().max(50, 'Postcode must be at most 50 characters'),
  country: yup.string().max(50, 'Country must be at most 50 characters'),
  state: yup.string().max(50, 'State must be at most 50 characters')
})

export const AddManageContentSchema = yup.object({
  type: yup.string().required('Type is required').max(50, 'Type must be at most 50 characters')
})
export const CreateContentSchema = yup.object({
  headline: yup.string().required('Headline is required'),
  category: yup
    .string()
    .required('Category is required')
    .test('is-not-default', 'Please select a specific category', value => value !== 'Section'),
  iress_category: yup.array().when('category', {
    is: 'announcement', // Condition: when category is "announcement"
    then: schema => schema.required('ASX category is required for announcements'),
    otherwise: schema => schema.notRequired() // Not required otherwise
  }),
  labels: yup.mixed().nullable(),
  publish: yup.string().max(50, 'Date must be at most 50 characters'),
  social_headline: yup.string(),
  social_description: yup.string()
})

export const CreateListSchema = yup.object({
  listName: yup.string().required('List name is required'),
  description: yup.string().required('Description is required')
})
export const CopyListSchema = yup.object({
  list: yup.number().required('List is required')
})

export const EmailListSchema = yup.object({
  email: yup
    .array()
    .of(yup.string().email('Invalid email address').required('Email is required'))
    .required('At least one email is required')
})

export const AddShareholderSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
  email: yup.string().email('Invalid email').required('Email is required'),
  address: yup.string(),
  hin_prefix: yup.string().oneOf(['X', 'I'], 'Choose X or I').required('Choose X or I'),
  hin_number: yup
    .string()
    .required('Holder number is required')
    .matches(/^\d{5}$/, 'Holder number must be exactly 5 digits')
})
export const InvestorUpdateSchema = yup.object({
  first_name: yup
    .string()
    .required('First name is required')
    .max(50, 'First name must be at most 50 characters'),
  last_name: yup
    .string()
    .required('Last name is required')
    .max(50, 'Last name must be at most 50 characters'),
  contact: yup
    .string()
    .nullable()
    .matches(
      /^\+(?:[0-9]●?\s?){8,12}[0-9]$/,
      `Phone Number should start with "+" and 8 digits long`
    ),
  email: yup.string().email('Invalid email address').required('Email is required'),
  status: yup
    .string()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .oneOf([null, 'active', 'suppressed', 'unsubscribed'], 'Invalid status'),
  street: yup.string().nullable().max(50, 'Street must be at most 50 characters'),
  city: yup.string().nullable().max(50, 'City must be at most 50 characters'),
  postcode: yup.string().nullable().max(50, 'Postcode must be at most 50 characters'),
  country: yup.string().nullable().max(50, 'Country must be at most 50 characters'),
  state: yup.string().nullable().max(50, 'State must be at most 50 characters')
})

export const AdminUpdateSchema = yup.object({
  first_name: yup
    .string()
    .required('First name is required')
    .max(50, 'First name must be at most 50 characters'),
  last_name: yup
    .string()
    .required('Last name is required')
    .max(50, 'Last name must be at most 50 characters'),
  contact: yup
    .string()
    .nullable()
    .matches(
      /^\+(?:[0-9]●?\s?){8,12}[0-9]$/,
      `Phone Number should start with "+" and 8 digits long`
    ),
  role_id: yup.number().required('Role is required'),
  email: yup.string().email('Invalid email address').required('Email is required'),
  street: yup.string().nullable().max(50, 'Street must be at most 50 characters'),
  city: yup.string().nullable().max(50, 'City must be at most 50 characters'),
  postcode: yup.string().nullable().max(50, 'Postcode must be at most 50 characters'),
  country: yup.string().nullable().max(50, 'Country must be at most 50 characters'),
  state: yup.string().nullable().max(50, 'State must be at most 50 characters')
})

export const AdminPermissionsUpdateSchema = yup.object({
  role: yup.string().max(50, 'Role must be at most 50 characters'),
  contact: yup
    .string()
    .required('Phone Number is required')
    .matches(
      /^\+(?:[0-9]●?\s?){8,12}[0-9]$/,
      `Phone Number should start with "+" and 8 digits long`
    ),
  email: yup.string().email('Invalid email address').required('Email is required'),
  street: yup.string().max(50, 'Street must be at most 50 characters'),
  notes: yup.string().max(50, 'Notes must be at most 50 characters')
})

export const InviteInvestorSchema = yup.object({
  emails: yup
    .array()
    .of(yup.string().email('Invalid email address').required('Email is required'))
    .required('At least one email is required')
})

export const ColourSchema = yup.object({
  p_colour: yup
    .string()
    .required('This is required')
    .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, 'Enter a valid color code'),
  s_colour: yup
    .string()
    .required('This is required')
    .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, 'Enter a valid color code'),
  email_bg_color: yup
    .string()
    .required('This is required')
    .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, 'Enter a valid color code')
  // p_is_dark_text: yup.boolean(),
  // s_is_dark_text: yup.boolean()
})

export const HomeThemeSchema = yup.object({
  title: yup.string().required('Title text is required'),
  text: yup.string().required('Secondary text is required')
})

export const AIPromptSchema = yup.object({
  workflow: yup.string().required('Workflow is required'),
  source: yup
    .array()
    .transform((value, originalValue) => {
      if (typeof originalValue === 'string') {
        return originalValue
          .split(',')
          .map((v: string) => v.trim())
          .filter(Boolean)
      }
      return value
    })
    .of(yup.string())
    .min(1, 'Please select at least one label')
    .required('Source is required'),

  name: yup.string().required('Prompt Name is required'),
  context: yup.string().required('Context is required'),
  prompt: yup.string().required('Prompt is required'),
  regeneration_prompt: yup.string().required('Regeneration prompt is required'),
  limit: yup.string().required('Limit is required'),
  example: yup.string().required('Example is required')
})

export const CompanySchema = yup.object({
  business: yup.string().required('Company name is required'),
  asx_code: yup.string().required('ASX code is required'),
  first_name: yup.string().required('First name is required'),
  last_name: yup.string().required('Last name is required'),
  email: yup.string().email('Invalid email address').required('Email is required')
})

export const SubscribersSchema = yup.object({
  frequency: yup.string().required('Frequency is required'),
  plan: yup.string().required('Plan is required'),
  start_date: yup.string().required('Start date is required'),
  end_date: yup.string().required('End date is required'),
  share_registry: yup.string().required('Share registry is required')
})

export const DomainSchema = yup.object({
  primary_domain: yup.string().required('Primary domain is required'),
  sub_domain: yup.string().matches(/\.$/, 'Sub-domain must end with a dot (.)')
})

export const IntegerationSchema = yup.object({
  issuer_id: yup.string().required('Issuer id is required'),
  security_id: yup.string().required('Security id is required'),
  // Escrowed share class identifiers (Automic) - optional, comma-separated
  escrow_securities: yup.string(),
  live_token: yup.string().required('Live token is required'),
  sandbox_token: yup.string().required('Sandbox token is required'),
  vector_store_id: yup.string().required('Vector store id is required')
})

// XCEND uses a read-only Security Code (the primary ticker) and an optional,
// comma-separated list of Escrowed Class Codes stored in `escrow_securities`.
export const IntegrationXcendSchema = yup.object({
  issuer_id: yup.string(),
  security_id: yup.string(),
  escrow_securities: yup.string(),
  live_token: yup.string().required('Live token is required'),
  sandbox_token: yup.string().required('Sandbox token is required'),
  vector_store_id: yup.string().required('Vector store id is required')
})
// MUFG has no API: the registry delivers a daily CSV feed, so no issuer id or
// security id is collected. Postmark and vector-store fields still apply.
export const IntegrationMufgSchema = yup.object({
  issuer_id: yup.string(),
  security_id: yup.string(),
  escrow_securities: yup.string(),
  live_token: yup.string().required('Live token is required'),
  sandbox_token: yup.string().required('Sandbox token is required'),
  vector_store_id: yup.string().required('Vector store id is required')
})

export const MovementSchema = yup.object({
  max: yup
    .string()
    .matches(/^(-?\d*\.?\d*)$/, 'Max value must be a valid number') // Matches a string that is either empty or contains only digits
    .test('max-greater-than-min', 'Max value should be more than Min value', function (value) {
      const { min } = this.parent
      return value === '' || min === '' || Number(value) >= Number(min)
    }),
  min: yup.string().matches(/^(-?\d*\.?\d*)$/, 'Max value must be a valid number') // Matches a string that is either empty or contains only digits
})

export const DateRangeSchema = yup.object({
  start_date: yup.string(),
  end_date: yup.string()
})

export const AddMemberSchema = yup.object({
  name: yup.string().required('Name is required'),
  title: yup.string().required('Title is required').max(50, 'Title cannot exceed 50 characters'),
  linkedin_link: yup.string().nullable(),
  x_link: yup.string().nullable(),
  other_link: yup.string().nullable(),
  bio: yup.string().nullable()
})

export const HeaderContentSchema = yup.object({
  title: yup
    .string()
    .required('Title is required')
    .test('max-words', 'Title cannot exceed 10 words', value => {
      if (!value) return true // required validator handles empty
      return value.trim().split(/\s+/).length <= 10
    })
})

export const WelcomSectionSchema = yup.object({
  welcome_title: yup
    .string()
    .required('Title is required')
    .test('max-words', 'Title cannot exceed 15 words', value => {
      if (!value) return true // required validator handles empty
      return value.trim().split(/\s+/).length <= 15
    }),
  welcome_message: yup
    .string()
    .required('Welcome message is required')
    .test('max-words', 'Welcome message cannot exceed 170 words', value => {
      if (!value) return true // required validator handles empty
      return value.trim().split(/\s+/).length <= 170
    }),
  rep_name: yup
    .string()
    .required('Representative name is required')
    .max(30, 'Representative name cannot exceed 30 characters'),
  rep_role: yup
    .string()
    .required('Representative role is required')
    .max(40, 'Representative role cannot exceed 40 characters'),
  youtube_link: yup.string().url('Enter a valid URL (e.g. https://example.com)').optional(),
  unith_link: yup.string().url('Enter a valid URL (e.g. https://example.com)').optional(),
  media_type: yup.string().required('Media Type is required')
})

export const SignUpSchema = yup.object({
  first_name: yup.string().required('First name is required'),
  last_name: yup.string().required('Last name is required'),
  email: yup.string().email('Invalid email address').required('Email is required')
})

export const CustomNewSchema = yup.object({
  link: yup
    .string()
    .required('Link is required')
    .url('Enter a valid URL (e.g. https://example.com)')
})

export const CompanyDetailsSchema = yup.object({
  business_name: yup.string().required('Company name is required'),
  code: yup.string().required('ASX code is required'),
  share_registry: yup.string().required('Share registry is required')
})

export const ThemeDetailsSchema = yup.object({
  p_color: yup.string().required('Primary colour is required'),
  s_color: yup.string().required('Secondary colour is required'),
  email_bg_color: yup.string().required('Email background color is required')
})

export const ReportGenerationSchema = yup.object({
  prompt: yup.string().required('Prompt is required'),
  structure_prompt: yup.string().required('Report structure propmt is required'),
  limit: yup.string().required('Limit is required')
})

export const AnnouncementGenerationSchema = yup.object({
  prompt: yup.string().required('Prompt is required'),
  regeneration_prompt: yup.string().required('Regeneration prompt is required')
})

export const twoFactorCodeSchema = yup.object({
  code: yup
    .string()
    .required('Enter the 6-digit code')
    .matches(/^\d{6}$/, 'Enter the 6-digit code')
})

export const WeeklyRecipientSchema = yup.object({
  name: yup
    .string()
    .trim()
    .required('Name is required')
    .max(100, 'Name must be at most 100 characters'),
  email: yup.string().trim().email('Invalid email address').required('Email is required'),
  role: yup.string().trim().max(100, 'Role must be at most 100 characters').default('')
})
